<script>
import Views from "./Views.vue";

export default {
  props: {
    layout: {
      type: Object,
      required: true,
    },
    setTopbarControls: {
      type: Function,
      required: false,
    },
    topbarControls: {
      type: Object,
      required: false,
    },
    active: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    Views,
  },
  // watch: {
  //   active(val) {
  //     if (val) {
  //       const self = this;
  //       this.setTopbarControls(self.layout);
  //     }
  //   },
  // },
  mounted() {
    if (this.active) {
      const self = this;
      this.setTopbarControls(self.layout);
    }
  },
};
</script>
<template>
  <div :style="layout.style" :class="`col-${layout.size} ${layout.class}`">
    <Views
      v-for="(child, index) in layout.children"
      :key="index"
      :view="child"
      :topbarControls="topbarControls"
      :setTopbarControls="setTopbarControls"
    />
  </div>
</template>

<style>
.flex {
  display: flex;
}
</style>
